import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import EventCard from 'src/components/ui/EventCard';
import ListingWrap from 'src/components/ui/ListingWrap';

const EventCards = (props) => {
	const { title, cards = [], wrap, notice } = props;
	const listingWrapProps = {
		...wrap,
		notice,
		empty: cards.length > 0 ? undefined : wrap?.empty,
	};

	return (
		<ListingWrap title={title} {...listingWrapProps}>
			{cards.length > 0 && (
				<Stack spacing={2}>
					{cards.map((card) => {
						return <EventCard key={card.id} {...card} />;
					})}
				</Stack>
			)}
		</ListingWrap>
	);
};

EventCards.propTypes = {
	title: PropTypes.string,
	wrap: PropTypes.shape(ListingWrap.propTypes),
	cards: PropTypes.arrayOf(PropTypes.shape(EventCard.propTypes)),
	notice: PropTypes.node,
};

export default EventCards;
